/**
 * Every string EntityTypeSelector renders itself, verbatim from the agreed copy. The tiles carry
 * their own copy (IndividualTile and the entity tiles). Optional intro content is the caller's.
 */

export const ENTITY_TYPE_SELECTOR_HEADING = 'Select Entity Type to Verify';

// The group titles are copied in person-api (Greengate-Fintech/person-api), the label mapping in
// src/main/java/com/greengate/verifime/service/notification/InviteEmailEntityData.java,
// and sent by CustomerInvitedNotificationHandler (event/vertx). Change both together.
export const ENTITY_TYPE_GROUP_TITLE = {
  organisation: 'Organisation',
  trust: 'Trust',
  business: 'Business',
} as const;

export const CANCEL_LABEL = 'Cancel';

export const CONTINUE_LABEL = 'Continue';

export const SAVING_LABEL = 'Loading...';
